<template>
  <VContainer fluid class="grad fill-height ma-0 pa-0">
    <VRow align="center" justify="center" class="fill-height">
      <VCol cols="12" md="10" lg="8" class="text-center">
        
        <VCard color="transparent" class="elevation-0">

          <!-- Logo -->
          <VImg
            class="mx-auto"
            max-width="500"
            :src="titleNegativo"
          />

          <!-- Título -->
          <div class="text-h2 mt-10 text-white font-weight-bold">
            {{ $t('TRIAL.SUCCESS') }}!
          </div>

          <!-- Descrição -->
          <div
            class="text-h5 mt-6 text-white font-weight-bold"
            style="white-space: pre-line;"
          >
            {{ $t('TRIAL.SUCCESS_DESCRIPTION') }}.
          </div>

          <!-- Contactos -->
          <div class="mt-12 text-white">
            <div class="text-h6 font-weight-medium mb-4">
              {{ $t('PRE_FOOTER.contacts') }}
            </div>

            <div class="d-flex justify-center align-center mb-2">
              <VIcon class="mr-2">mdi-email</VIcon>
              <span class="text-h6 font-weight-light">info@reportlake.com</span>
            </div>

            <div class="d-flex justify-center align-center">
              <VIcon class="mr-2">mdi-clock</VIcon>
              <span class="text-h6 font-weight-light">
                {{ $t('PRE_FOOTER.work_week') }} - 9h {{ $t('PRE_FOOTER.to') }} 18h
              </span>
            </div>
          </div>

        </VCard>

      </VCol>
    </VRow>
  </VContainer>
</template>



<script>
import titleNegativo from '@/assets/icons/title_negativo.png'

export default {
  name: 'SuccessTrial'
}
</script>

<style>
.grad{
  background-image: linear-gradient(#0B0E17, #3D4A6D);
}

.semi-circle-success{
  --shadow-size: 4vmin;
  aspect-ratio: 1;
  background: #3D4A6D;
  border-radius: 50%;
  box-shadow:
    var(--shadow-size) var(--shadow-size) 0 var(--shadow-size) #364363,
    calc(2 * var(--shadow-size)) calc(2 * var(--shadow-size)) 0 calc(2 * var(--shadow-size)) #26324C;
  width: 90vmin;
  position: absolute;
  bottom: 100%;
  right: 100%;
  transform: translate(75%,75%);
  z-index: 1;
}
</style>
